// Enums can't be declared in declaration files (e.g. global.d.ts).
// Eveything looks during compile, but at runtime, you'll get error
// "[EnumName] is not defined".  So we'll put them here.

export enum RegistrySearchFlags {
  None = 0,
  Keys = 1 << 0,
  Values = 1 << 1,
  Data = 1 << 2,
  WholeStringOnly = 1 << 3,
}
